// extracted by mini-css-extract-plugin
export default {"root":"DeleteButton_root__uVdf4","icon":"DeleteButton_icon__hq4WK"};